import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { userService } from '../../services/user.service';
import { FaCheck, FaTimes } from 'react-icons/fa';

const Approvals = () => {
  const [pendingUsers, setPendingUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPendingUsers();
  }, []);

  const fetchPendingUsers = async () => {
    try {
      const data = await userService.getAllUsers({ status: 'pending' });
      setPendingUsers(data.users || []);
    } catch (error) {
      toast.error('Failed to fetch pending users');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (userId) => {
    try {
      await userService.approveUser(userId);
      toast.success('User approved!');
      fetchPendingUsers();
    } catch (error) {
      toast.error('Failed to approve user');
    }
  };

  const handleReject = async (userId) => {
    if (!window.confirm('Reject this user?')) return;
    try {
      await userService.deleteUser(userId);
      toast.success('User rejected');
      fetchPendingUsers();
    } catch (error) {
      toast.error('Failed to reject user');
    }
  };

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Pending Approvals</h1>

      <div className="bg-white rounded-lg shadow">
        {loading ? (
          <div className="p-8 text-center">Loading...</div>
        ) : pendingUsers.length === 0 ? (
          <div className="p-8 text-center text-gray-500">No pending approvals</div>
        ) : (
          <div className="divide-y">
            {pendingUsers.map((user) => (
              <div key={user._id} className="p-6 hover:bg-gray-50">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold">{user.name}</h3>
                    <p className="text-gray-600">{user.email}</p>
                    <div className="mt-2 space-y-1 text-sm text-gray-500">
                      <p><span className="font-medium">Role:</span> {user.role?.displayName}</p>
                      <p><span className="font-medium">Department:</span> {user.department?.name}</p>
                      <p><span className="font-medium">Phone:</span> {user.phone}</p>
                      <p><span className="font-medium">Registered:</span> {new Date(user.createdAt).toLocaleDateString()}</p>
                    </div>
                  </div>
                  <div className="flex gap-2">
                    <button onClick={() => handleApprove(user._id)} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center gap-2">
                      <FaCheck /> Approve
                    </button>
                    <button onClick={() => handleReject(user._id)} className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 flex items-center gap-2">
                      <FaTimes /> Reject
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Approvals;
